import React from 'react';
import { Box, Typography, Stack, SxProps, Theme } from '@mui/material';

interface PageWrapperProps {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ 
  title, 
  actions, 
  children,
  sx 
}) => {
  return (
    <Box sx={{ width: '100%', maxWidth: '100%', ...sx }}>
      <Stack 
        direction={{ xs: 'column', sm: 'row' }} 
        justifyContent="space-between" 
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Typography 
          variant="h4" 
          component="h1"
          sx={{ 
            fontSize: { xs: '1.75rem', sm: '2.125rem' },
            wordBreak: 'break-word'
          }}
        >
          {title}
        </Typography>
        {actions && (
          <Box 
            sx={{ 
              display: 'flex', 
              gap: 1,
              flexWrap: 'wrap',
              justifyContent: { xs: 'flex-start', sm: 'flex-end' }
            }}
          >
            {actions}
          </Box>
        )}
      </Stack>
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        {children}
      </Box>
    </Box>
  );
};

export default PageWrapper;